/**
 * The merchant app route that starts (or resumes) Gale identity verification
 * for a team. Opening it mints a fresh hosted onboarding link server-side (the
 * merchant `startGaleKyc` RPC) and redirects there, so unlike the hosted link
 * itself this path never expires. Every surface that sends a merchant back
 * into KYC (Redo Admin, the SE Slack alert, any merchant-facing message)
 * builds its URL from this one path.
 */
export function galeKycPath(teamId: string): string {
  return `/stores/${teamId}/conversion/kyc`;
}
